// Module
var code = "<section class=\"sw-date-time-picker\"> <sw-date-picker date=\"$ctrl.value\" sw-change=\"$ctrl.setDate(value)\"></sw-date-picker> <div uib-timepicker ng-model=\"$ctrl.hour\" ng-change=\"$ctrl.setHour($ctrl.hour)\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"false\"></div> </section> ";
// Exports
export default code;